<template>
  <BaseCustomizeMetal componentCode="AJ" />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalAJ",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 104px;
    left: 136px;
    @include betweenTableTablePro {
      top: 66px;
      left: 89px;
    }
    @include table {
      top: 51px;
      left: 65px;
    }
    @include phone {
      top: 40px;
      left: 51px;
    }
  }
  .templeName {
    height: 28px;
    width: 156px;
    .textContainer {
      width: 156px;
    }
  }
  .godName {
    width: 220px;
    height: 58px;
    .textContainer {
      width: 220px;
    }
  }
  .gift {
    width: 154px;
    height: 22px;
    .textContainer {
      width: 154px;
    }
  }
}
</style>
